/**
 * Bill hours source type DTO enum - matches backend API contract
 * Represents the type of hours source for invoice calculations
 */
export enum BillHoursSourceTypeDTO {
  TRACKED = 'TRACKED',
  BOOKED = 'BOOKED',
  CAPACITY = 'CAPACITY',
  APPROVED = 'APPROVED',
  TIME_OFF = 'TIME_OFF',
}

/**
 * Type aliases for clear intent in request/response interfaces
 */
export type BillHoursSourceTypeRequest = BillHoursSourceTypeDTO;
export type BillHoursSourceTypeResponse = BillHoursSourceTypeDTO;
